export function notEmptyValidation(value: unknown) {
  return !!value;
}
